import { SALE_FACTORY_ABI } from '@lfg/abis';
import { Abi } from 'viem';

import { MAINNET_SALE_FACTORY_ADDRESS, TESTNET_SALE_FACTORY_ADDRESS } from '../config/common.config';
import { SmartContract } from '../types/contract.type';

const testnetSaleFactoryContract: SmartContract = {
  abi: SALE_FACTORY_ABI as Abi,
  address: TESTNET_SALE_FACTORY_ADDRESS,
};

const mainnetSaleFactoryContract: SmartContract = {
  abi: SALE_FACTORY_ABI as Abi,
  address: MAINNET_SALE_FACTORY_ADDRESS,
};

export { testnetSaleFactoryContract, mainnetSaleFactoryContract };
